<div class="[&_a]:no-underline [&_a:hover]:underline">
  <!-- <div >
<lib-brands   [theme]="theme" [brands]="brands"
></lib-brands></div>-->
  <lib-footer [labels]="'lib.footer' | translate" [displayOurAppLink]="false" [baseLogo]="baseLogo" [bankLogo]="bankLogo"
    [bankDescription]="bankDescription" [usefullLinksList]="usefullLinksList" [majorCategories]="majorCategories"
    [bankColor]="theme" [aboutUsLinks]="aboutUsLinks" [socialMediaLinks]="socialMediaLinks"
    [ctaSecondaryLink]="storesLink" [moreProductsLink]="moreProductsLink" [copyrightProjectName]="'WISSAL UNIVERS'"
    [ctaBadgeLabel]="cta.badge" [ctaTitle]="cta.title" [ctaDescription]="cta.description"
    [ctaPrimaryLabel]="cta.primary" [ctaSecondaryLabel]="cta.secondary">
  </lib-footer>
</div>